import script from "./DefaultFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./DefaultFooter.vue?vue&type=script&setup=true&lang=ts"

import "./DefaultFooter.vue?vue&type=style&index=0&id=d2dda692&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2dda692"]])

export default __exports__